import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "innerModal" }
const _hoisted_2 = {
  key: 0,
  class: "bottommargin labeldiv"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle btm-1" }, "Assigned product:", -1)
const _hoisted_4 = { class: "titlestyle btm-1" }
const _hoisted_5 = { class: "bottommargin" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle btm-1" }, "Assigned add-on:", -1)
const _hoisted_7 = { class: "titlestyle btm-1" }
const _hoisted_8 = { class: "btm-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle topmargin btm-1" }, "License type:", -1)
const _hoisted_10 = { class: "titlestyle bottommargin" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle btm-1" }, "Assigned users:", -1)
const _hoisted_12 = { class: "sumusersdiv breaking-words" }
const _hoisted_13 = { style: {"margin":"0"} }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = {
  key: 1,
  class: "bottommargin labeldiv"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle btm-1" }, "Assigned add-on:", -1)
const _hoisted_17 = { class: "titlestyle btm-1" }
const _hoisted_18 = { class: "btm-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "summarytitle" }, "License type:", -1)
const _hoisted_20 = { class: "titlestyle bottommargin" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle topmargin btm-1" }, "Assigned users:", -1)
const _hoisted_22 = { class: "sumusersdiv" }
const _hoisted_23 = { class: "font-regular-16 breaking-words" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.detailsOf === 'product')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.product.productName), 1),
          _createElementVNode("label", _hoisted_5, " Version: " + _toDisplayString(_ctx.product.majorVersionNumber) + "." + _toDisplayString(_ctx.product.minorVersionNumber), 1),
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedAddons, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.productName), 1),
              _createElementVNode("div", _hoisted_8, " Version: " + _toDisplayString(item.majorVersionNumber) + "." + _toDisplayString(item.minorVersionNumber), 1)
            ]))
          }), 128)),
          _hoisted_9,
          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.product.licenseType), 1),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUsers, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("p", _hoisted_13, [
                  _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                  _hoisted_14,
                  _createTextVNode(" (" + _toDisplayString(item.email) + " ) ", 1)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.detailsOf === 'addon')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedAddons, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, _toDisplayString(item.productName), 1),
              _createElementVNode("div", _hoisted_18, " Version: " + _toDisplayString(item.majorVersionNumber) + "." + _toDisplayString(item.minorVersionNumber), 1),
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, _toDisplayString(item.licenseType), 1)
            ]))
          }), 128)),
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUsers, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("label", _hoisted_23, _toDisplayString(item.firstName) + ", " + _toDisplayString(item.lastName) + " " + _toDisplayString(item.lastname) + ", " + _toDisplayString(item.email), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}